// Modes de sélection sur le graphe / tableau
export const WINDOW = 'window'
export const POINT = 'point'
export const HISTORIC = 'historic'
export const NEWPOINT = 'newPoint'
export const MOVING = 'moving'

// Outils du panneau latéral
export const VALIDATION = 'validation'
export const PURGE = 'purge'
export const IMPORT = 'import'
export const COMPENSATION = 'compensation'
export const CORRECTION = 'correction'
export const OPTIONS = 'options'
export const THRESHOLDS = 'thresholds'
export const EVENT = 'event'

// Sous-modes de l'outil suppression
export const RESET = 'reset'
export const DELETE = 'delete'

// Modes d'affichage de la zone centrale
export const TABLE = 'table'
export const GRAPH = 'graph'

// Clé localStorage des options graphique (échelle Y) — pas de persistance backend
// côté pluvio (cf. PluvioSuiviChartOptionsTab qui fait déjà du localStorage).
export const PLUVIO_VALIDATION_CHART_OPTIONS = 'PLUVIO_VALIDATION_CHART_OPTIONS'

// Groupement par défaut : mesures brutes (la validation opère sur les points stockés).
export const DEFAULT_VALIDATION_DISPLAY_MODES = {
    auto: false,
    all: true,
    sumHour: false,
    sumDay: false,
    sumWeek: false,
    sumDecade: false,
    sumMonth: false,
    sumYear: false,
    personalizedGrouping: false,
}
